export class InputFieldReference{
    public index!: number;
    public name!: string;
}